import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Wrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/ProcedureInformation/styled-components';
import { Listings } from 'containers/AppContainer/typings';
import { Idetails } from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/typings';
import ProcedureInformationForm from 'containers/common/LegalProceedings/JudgementAdd/Forms/ProcedureInformation/index';
import { Vehicule } from 'containers/PreOpeningPage/typings.d';

export interface ProcedureInformationProps {
  intl: IntlShape;
  listings: Listings;
  details: Idetails;
  vehicules: Vehicule[];
  setDetails: Function;
  processInformationValidation?: any;
  messageError?: any;
  lossDate: string;
  sagisOpposingParties: any;
  currentJudiciaryProcess: any;
}

const ProcedureInformation: React.FC<ProcedureInformationProps> = ({
  listings,
  details,
  setDetails,
  vehicules,
  processInformationValidation,
  messageError,
  lossDate,
  ...props
}): JSX.Element => {
  return (
    <Wrapper>
      <ProcedureInformationForm
        details={details}
        setDetails={setDetails}
        vehicules={vehicules}
        listings={listings}
        processInformationValidation={processInformationValidation}
        messageError={messageError}
        lossDate={lossDate}
        sagisOpposingParties={props.sagisOpposingParties}
        currentJudiciaryProcess={props.currentJudiciaryProcess}
      />
    </Wrapper>
  );
};

export default injectIntl(ProcedureInformation);
